import { useContext, useMemo } from "react";
import { seasonalDataHelpers } from "../cnr/reducers/reducerHelpers/seasonalDataHelpers";
import { createSportsHelpers } from "../cnr/reducers/reducerHelpers/createSportsData";
import { sportTournamentHelpers } from "../helpers/tournamentData";
import { ParentContext } from "global/cnr/contexts/ParentContext";
import { seasonalHelpers } from "../cnr/reducers/reducerHelpers/seasonalHelpers";
import { sportsDataHelpers } from "../cnr/reducers/reducerHelpers/sportsDataHelpers";

export const useSeasonals = () => {
  // ✅ Optional: memoize to avoid re-creating the object
  return useMemo(() => seasonalHelpers, []);
};

export const useSeasonalData = () => {
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { appUser_state, paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}
  // ✅ Optional: memoize to avoid re-creating the object
  return useMemo(() => seasonalDataHelpers(database_fns, pathViews), []);
};


export const useSportsData = () => {
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}
  // ✅ Optional: memoize to avoid re-creating the object
  return useMemo(() => sportsDataHelpers(database_fns, pathViews), []);
};


export const useCreateSports = () => {
  // ✅ Optional: memoize to avoid re-creating the object
  return useMemo(() => createSportsHelpers, []);
};

export const useSportsTournaments = () => {
  // ✅ Optional: memoize to avoid re-creating the object
  return useMemo(() => sportTournamentHelpers, []);
};